<app-loader [loader]="loader.count" *ngIf="loader.count > 0"></app-loader>
<div class="list_header container">
  <div class="row">
    <div class="col-12">
      <div class="languages text-end">
        <ng-container *ngFor="let lang of availableLanguages; last as isLast">
          <a class="language-selector" (click)="setLang(lang)" [class.bold]="currentLanguage === lang">{{ 'COMMON.LANGS_' + lang.toUpperCase() | translate }}</a>
          <span *ngIf="!isLast">&nbsp;|&nbsp;</span>
        </ng-container>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-lg-2 col-md-6 col-xs-12">
      <div class="logo-fira"><img src="/assets/img/cropped-cropped-logo-fira-1-blue.png" alt="Fira Barcelona" /></div>
    </div>
    <div class="col-lg-6 col-md-6 col-xs-12">
      <div class="catalogue_list_title">{{ 'HALLS_LIST.TITLE' | translate }}</div>
    </div>
    <div class="col-lg-4 col-md-12 col-xs-12 links">
      <div class="row">
        <div class="col-md-6 col-12">
          <div class="link-wrapper link first">
            <a target="_blank" href="https://www.firabarcelona.com/{{ currentLanguage }}/exhibitor">{{ 'HALLS_LIST.EXHIBITORS' | translate }}</a>
          </div>
        </div>
        <div class="col-md-6 col-12">
          <div class="link-wrapper link first">
            <a target="_blank" href="https://fira-news.com/{{ currentLanguage }}">{{ 'HALLS_LIST.FIRA_NEWS' | translate }}</a>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6 col-12">
          <div class="link-wrapper">
            <a target="_blank" href="https://www.firabarcelona.com/{{ currentLanguage }}/visitante">{{ 'HALLS_LIST.VISITORS' | translate }}</a>
          </div>
        </div>
        <div class="col-md-6 col-12">
          <div class="link-wrapper">
            <a target="_blank" href="http://www.firabarcelona.com/{{ currentLanguage }}/contact">{{ 'HALLS_LIST.CONTACT' | translate }}</a>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6 col-12">
          <div class="link-wrapper">
            <a target="_blank" href="http://www.firabarcelona.com/{{ currentLanguage }}/organizers">{{ 'HALLS_LIST.ORGANIZERS' | translate }}</a>
          </div>
        </div>
        <div class="col-md-6 col-12">
          <div class="link-wrapper">
            <div>
              <a target="_blank" href="http://twitter.com/#!/fira_barcelona" class="social fab fa-twitter-square" aria-hidden="true"></a>
              <a target="_blank" href="https://www.facebook.com/FiradeBarcelona/" class="social fab fa-facebook-square" aria-hidden="true"></a>
              <a target="_blank" href="https://es.linkedin.com/company/fira-barcelona" class="social fab fa-linkedin" aria-hidden="true"></a>
              {{ 'HALLS_LIST.FOLLOW_US' | translate }}
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6 col-12">
          <div class="link-wrapper">
            <a target="_blank" href="http://www.firabarcelona.com/{{ currentLanguage }}/contractor_profile">{{ 'HALLS_LIST.CONTRACTOR_PROFILE' | translate }}</a>
          </div>
        </div>
        <div class="col-md-6 col-12"></div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="tab-table">
      <ul class="nav nav-tabs">
        <li class="main-link">
          <a target="_blank" href="http://www.firabarcelona.com/{{ currentLanguage }}/institution">{{ 'HALLS_LIST.TABS.INSTITUTION' | translate }}</a>
        </li>
        <li class="main-link">
          <a target="_blank" href="http://www.firabarcelona.com/{{ currentLanguage }}/calendar/-/show/2018">{{ 'HALLS_LIST.TABS.CALENDAR' | translate }}</a>
        </li>
        <li class="main-link">
          <a target="_blank" href="http://www.firabarcelona.com/{{ currentLanguage }}/venues">{{ 'HALLS_LIST.TABS.FAIR_GROUNDS' | translate }}</a>
        </li>
        <li class="main-link">
          <a target="_blank" href="http://www.firabarcelona.com/{{ currentLanguage }}/international">{{ 'HALLS_LIST.TABS.INTERNATIONAL' | translate }}</a>
        </li>
        <li class="main-link">
          <a target="_blank" href="http://www.firabarcelona.com/{{ currentLanguage }}/barcelona">{{ 'HALLS_LIST.TABS.BARCELONA' | translate }}</a>
        </li>
        <li class="main-link">
          <a target="_blank" href="http://www.firabarcelona.com/{{ currentLanguage }}/press">{{ 'HALLS_LIST.TABS.PRESS' | translate }}</a>
        </li>
      </ul>
    </div>
  </div>
</div>
<div class="main-container container hall-list margin-container" [hidden]="loader.count > 0">
  <div class="halls-list">
    <div class="hall" *ngFor="let card of cards" [title]="'HALLS_LIST.SEE_CATALOGUE' | translate" [ngStyle]="{ 'border-color': card.mainColor || '#3c7dbd' }" (click)="goTo(card)">
      <div class="hall__header" [title]="'HALLS_LIST.SEE_CATALOGUE' | translate" [ngStyle]="{ 'background-color': card.headerColor || '#3c7dbd' }">
        <img [src]="card.imageLogo" class="hall__img" />
      </div>
      <div class="hall__body" [title]="'HALLS_LIST.SEE_CATALOGUE' | translate" [ngStyle]="{ 'background-color': card.mainColor || '#3c7dbd' }">
        <span class="hall__name">{{ card.label }}</span>
      </div>
    </div>
  </div>
</div>
<div class="copyright">
  <a class="footer-link pointer" [ngStyle]="{ color: '#636363' }" target="_blank" href="https://www.firabarcelona.com/{{ currentLanguage }}">© {{ currentYear }} {{ 'FOOTER.FIRA_BARCELONA' | translate }}</a>
  <span class="not_mobile_only">&nbsp;|&nbsp;</span>
  <a class="footer-link pointer" [ngStyle]="{ color: '#636363' }" target="_blank" href="https://www.firabarcelona.com/{{ currentLanguage }}/general-information">{{ 'FOOTER.LEGAL_INFO' | translate }}</a>
  <span class="not_mobile_only">&nbsp;|&nbsp;</span>
  <a class="footer-link pointer" [ngStyle]="{ color: '#636363' }" target="_blank" href="https://www.firabarcelona.com/{{ currentLanguage }}/legal-advice">{{ 'FOOTER.LEGAL_WARNING' | translate }}</a>
  <span class="not_mobile_only">&nbsp;|&nbsp;</span>
  <a class="footer-link pointer" [ngStyle]="{ color: '#636363' }" target="_blank" href="https://www.firabarcelona.com/{{ currentLanguage }}/privacy">{{ 'FOOTER.PRIVACY_POLICY' | translate }}</a>
  <span class="not_mobile_only">&nbsp;|&nbsp;</span>
  <a class="footer-link pointer" [ngStyle]="{ color: '#636363' }" target="_blank" href="https://www.firabarcelona.com/{{ currentLanguage }}/web-map">{{ 'FOOTER.WEB_MAP' | translate }}</a>
</div>
